<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 v-if="model">创建新团队</h4>
        <h4 v-else>编辑团队信息</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="p-6">
        <vs-input label="团队名称" name="title" v-model="title" class="mt-5 w-full" placeholder="起个厉害的名字！" />
        <vs-input label="团队口号" name="slogan" v-model="slogan" class="mt-5 w-full" placeholder="喊出你们的口号！"/>
      </div>
      <div class="p-6">
        <p class="text-sm mb-1 ml-2">团队头像</p>
        <div class="flex justify-between">
          <upload-image class="mr-4" v-if="!isUseDefaultAvatar" :default="defaultImg" :url="imgPath" @url="getUploadResult"></upload-image>
          <vx-card class="md:w-1/2 default-avatar">
            <img :src="defaultImg" style="width:100%" alt="team" @click="seletedDefaultAvatar">
            <p v-if="!isUseDefaultAvatar" class="text-center text-base">使用默认头像</p>
          </vx-card>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button v-if="model" class="mr-6" @click="addData">提交</vs-button>
      <vs-button v-else class="mr-6" @click="updateData">保存</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">取消</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>

import { add, update } from '@/api/team'
import { getToken } from '@/utils/tools';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import UploadImage from '@/components/upload/UploadImage'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    model: {
      type: Boolean,
      required: true
    },
    rule: {
      type: Object,
    }
  },
  data() {
    return {
      id: '',
      title: '',
      slogan: '',
      defaultImg: require('@/assets/images/team/default_team.png'),
      imgPath: '',
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
      isUseDefaultImg: false
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        this.initValues()
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar', false);
        }
      }
    },
    isUseDefaultAvatar() {
      return this.isUseDefaultImg
    }
  },
  created() {
    
  },
  methods: {
    initValues() {
      if (!this.model) {
        this.id = this.rule.id
        this.title = this.rule.teamName
        this.slogan = this.rule.teamSlogan
        this.imgPath = this.rule.imgSrc
      } else {
        this.id = ''
        this.imgPath = ''
      }
      this.isUseDefaultImg = false
    },
    getUploadResult(payload) {
      this.imgPath = payload
    },
    addData() {
      let that = this
      add({
        access_token: getToken(),
        teamName: that.title,
        imgSrc: that.imgPath,
        slogan: that.slogan
      }).then(res => {
        const data = res.data
        this.$vs.notify({
          title:'成功',
          text: data.err_msg,
          color:'success',
          iconPack: 'feather',
          icon:'icon-alert-circle'
        })
        that.$emit('closeSidebar', true);
      })
    },
    updateData() {
      let that = this
      update({
        access_token: getToken(),
        teamName: that.title,
        imgSrc: that.imgPath,
        slogan: that.slogan,
        teamId: that.id
      }).then(res => {
        const data = res.data
        this.$vs.notify({
          title:'成功',
          text: data.err_msg,
          color:'success',
          iconPack: 'feather',
          icon:'icon-alert-circle'
        })
        that.$emit('closeSidebar', {id: that.id, teamName: that.title, imgSrc: that.imgPath, teamSlogan:that.slogan});
      })
    },
    seletedDefaultAvatar() {
      this.imgPath = ''
      this.isUseDefaultImg = true
    }
  },
  components: {
    VuePerfectScrollbar,
    UploadImage,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

.default-avatar:hover {
  cursor: pointer;
  box-shadow: 1px 1px 24px #ccc;
}
</style>
